import { useEffect } from "react";
import { getDonationIsValid } from "@qgiv/donation-form";
import { log } from "@qgiv/core-js";

/**
 *
 * @param {object} props
 * @param {object} props.preparedValues
 * @returns {null}
 */
const ValidateOnePayDonation = ({ preparedValues }) => {
    useEffect(() => {
        let apiMounted = true;
        getDonationIsValid(preparedValues)
            .then((response) => {
                if (apiMounted) {
                    // We can trust to response to result in some sort of boolean
                    // which we can then either begin the processing flow
                    // or handle validation errors / race conditions. Once we figure out
                    // how we are going to integrate with the OnePay component wrapper,
                    // we will be able to handle the responses here correctly. This will
                    // also be called for Express Donate down the line, so we might have
                    // branching logic based on where that code ends up living (here or One Pay)
                    log({ response });
                }
            })
            .catch((err) => {
                if (apiMounted) {
                    log({ err });
                }
            });
        return () => {
            apiMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

export default ValidateOnePayDonation;
